import { useQuery } from "@tanstack/react-query";
import { fetchJson } from "@/lib/queryClient";
import type { CardState } from "@shared/cardRule";

/**
 * The reader's company and the card-on-file rule (shared/cardRule.ts). Null
 * fields for SaleFish staff and for anyone without a company: the rule never
 * applies to them. Read by CardGate (the lock) and CardNudge (the prompt).
 */
export interface CardStatus extends CardState {
  isCompanyAdmin: boolean;
  companyName: string | null;
}

export const CARD_STATUS_KEY = ["/api/card-status"] as const;

export function useCardStatus(enabled: boolean) {
  return useQuery({
    queryKey: CARD_STATUS_KEY,
    queryFn: () => fetchJson<CardStatus>("/api/card-status"),
    enabled,
    staleTime: 60_000,
    // A lock that begins while the app is open shows on the next focus.
    refetchOnWindowFocus: true,
    meta: { quiet: true },
  });
}

/**
 * The last day a card can be added, as shown to the reader: the deadline is
 * the instant the lock begins (midnight), so the day before it.
 */
export function lastCardDay(deadline: string): Date {
  return new Date(new Date(deadline).getTime() - 1);
}
